export default __webpack_public_path__ + "static/media/xver-v3-full.b136f96a.png";